import { render, staticRenderFns } from "./PsPatientEventsHistory.vue?vue&type=template&id=066131be&scoped=true&"
import script from "./PsPatientEventsHistory.vue?vue&type=script&lang=js&"
export * from "./PsPatientEventsHistory.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientEventsHistory.vue?vue&type=style&index=0&id=066131be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066131be",
  null
  
)

export default component.exports